<template>
  <div class="infoUser">
    <ModalCartaoDesassociado :open="modalCardDissociated" />
    <div class="info">{{returnGreetings}} <span >{{ t('CARTAO', [returnFullField("cardNumber")]) }}</span></div>
    <div class="extrato">
      <div class="credito">
          {{ t('SALDO_VALIDAR') }} <span>R${{formatMoney(returnFullField("creditBalance"))}}</span>
          <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <img v-on="on" src="../assets/img/interrogacaovazada.svg"/>
          </template>
          <span>{{ t('SALDO_VALIDAR_INFO') }}</span>
        </v-tooltip>
      </div>
      <div class="saldo">
        {{ t('SALDO_NO_CARTAO') }}  <span>R${{formatMoney(returnFullField("cardBalance"))}}</span>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <img v-on="on" src="../assets/img/interrogacaovazada.svg"/>
          </template>
          <span>{{ t('SALDO_NO_CARTAO_INFO') }}</span>
        </v-tooltip>
       
      </div> 
      <div class="promo">
        {{ t('CREDITOS_PROMOCIONAIS') }}  <span>R${{formatMoney(returnFullField("promoBalance"))}}</span>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <img v-on="on" src="../assets/img/interrogacaovazada.svg"/>
          </template>
          <span>{{ t('CREDITOS_PROMOCIONAIS_INFO') }}</span>
        </v-tooltip>
      </div>
    </div>
  </div>
</template>
<script>



import {VTooltip} from 'vuetify/lib'
import {formatMoney,resolvePromise,emitToParent} from '../helpers/helpers.js'
import {myUser} from '../services/user.service'
import {checkCard,cardPending} from '../services/sbe.service'
import ModalCartaoDesassociado from '@/components/ModalCartaoDesassociado.vue'
import { translate } from '../services/translate.service';
export default {
  name: 'InfoUser',
  data(){
    return{
      modalCardDissociated:null,
      creditBalance:null,
      cardBalance:null,
      promoBalance:null
    }
  },
  components:{
    VTooltip,
    ModalCartaoDesassociado
  },
  computed:{
    returnGreetings: function(){
      if(!this.name && !this.lastName) return translate('BEMVINDO');

      return translate('BEMVINDO_USUARIO', [`${this.name} ${this.lastName}`]);
    },
    hasCards: function(){
      return (this.cards && this.cards.length > 0)
    },
    hasActiveCard:function(){
      return this.activeCard
    }

  },
  methods:{
    t:translate,
    returnFullField: function(key){
      if(this.activeCard && this.activeCard[key]) return this.activeCard[key]
      if(this[key]) return this[key]
      if(key === "cardNumber") return ''
      return 0
    },
    getFullBallance: function({cardNumber}){
      if(!cardNumber) return
      resolvePromise(checkCard(cardNumber),({data}) =>{
        this.cardBalance = (parseInt(data.balance.replace(",","") * 100))
        emitToParent("changeActiveCard",this,{cardBalance:(parseInt(data.balance.replace(",","") * 100))})
        
        },console.log,this)
      
      resolvePromise(cardPending(cardNumber),({data}) =>{
        this.creditBalance = parseInt(data.PENDING.replace(",",""))
        this.promoBalance = parseInt(data.PENDINGPROMO.replace(",",""))
        emitToParent("changeActiveCard",this,{creditBalance:(parseInt(data.PENDING.replace(",",""))),promoBalance:(parseInt(data.PENDINGPROMO.replace(",","")))})
      
      },console.log,this)
    },
    formatMoney: number => formatMoney(number),
    _mount() {
    resolvePromise(myUser(),({data})=>{
      const
        {lastName, name, cards,activeCard} = data
      
      this.lastName = lastName
      this.name = name
      this.cards = cards
      this.activeCard = activeCard

      emitToParent("userData",this,data);  
      this.getFullBallance(data.activeCard)
    },(err) => {
      if(err == 'CARD-DISSOCIATED') {
        //emitToParent('cardDissociated', this, true);
        this.modalCardDissociated = true;
        this._mount();
      } else {
        console.log(err);
      }
    },this)
  },
  },
  props: {
    lastName: {
      type: String
    },
    name:{
      type: String
    },
    cards:{
      type:Array
    },
    activeCard:{
      type:Object
    }
  },
  created(){
    this._mount();
  }
}
</script>

<style scoped lang="scss">
  @import "../assets/scss/infoUser.scss";
</style>
